// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.payroll-register {
  flex: 1 1;
  display: flex;
  width: 100%;
  flex-direction: column;
}
.payroll-register__head {
  font-size: 28px;
}
.payroll-register__body {
  display: flex;
  margin-top: 20px;
  padding: 2%;
  flex-direction: column;
  border-radius: 16px;
  background: #ffffff;
  gap: 10px;
}
.payroll-register__body__head {
  display: flex;
}
.payroll-register__body__settlement-date {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #999999;
}
.payroll-register__body__settlement-date-data {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #075453;
}

.payroll-select {
  display: flex;
  margin-top: 30px;
}
.payroll-select__salary {
  margin-right: 10px;
}
.payroll-select__dropdown {
  width: 170px;
  height: 40px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 8px 8px 8px 8px;
}

.selected-details {
  margin-top: 50px;
  display: flex;
}
.selected-details__excel {
  float: right;
  margin-left: auto;
}
.selected-details__excel-button {
  height: 38px;
  border: 1px solid #e1e1e1;
  padding: 7px;
  padding-left: 20px;
  padding-right: 20px;
  border-radius: 10px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #505054;
  cursor: pointer;
}

.payroll-table {
  flex: 1 1;
  display: flex;
  margin-top: 30px;
  width: 100%;
  overflow-x: auto;
}
.payroll-table__table-sticky {
  border-collapse: collapse;
  white-space: nowrap;
  border-style: hidden;
  border-radius: 6px 0px 0px 6px;
  box-shadow: 10px 0 12px -2px rgba(0, 0, 0, 0.1);
}
.payroll-table__table-scrollable::-webkit-scrollbar {
  display: block;
}
.payroll-table__table-scrollable {
  display: block;
  overflow-x: auto;
  white-space: nowrap;
  border-collapse: collapse;
  border-radius: 0px 6px 6px 0px;
}
.payroll-table__table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  border-radius: 6px;
  border-style: hidden;
  box-shadow: 0 0 0 1px #e9e9e9;
}
.payroll-table__th-head {
  padding: 20px;
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #505054;
  background: #f9fafb;
}
.payroll-table__td {
  text-align: center;
  border-bottom: 1px solid #e9e9e9;
  border-top: 1px solid #868686;
  height: 60px;
  padding: 15px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  color: #566370;
}
.payroll-table__th {
  text-align: center;
  border: 1px solid #d9d9d9;
  height: 71px;
  border-radius: 6px 0px 0px 6px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #868686;
}
.payroll-table__th-in {
  text-align: center;
  height: 60px;
  padding: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #868686;
  background: #f9fafb;
}
.payroll-table__th-in-b-right {
  text-align: center;
  height: 60px;
  padding: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  align-items: center;
  color: #868686;
  border-right: 1px solid #d9d9d9;
}
.payroll-table__th-botton {
  text-align: center;
  height: 60px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  border-top: 1px solid #c1c1c1;
  border-bottom: 1px solid #c1c1c1;
}
.payroll-table__th-botton-b-right {
  text-align: center;
  height: 60px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  border-top: 1px solid #c1c1c1;
  border-right: 1px solid #d9d9d9;
  border-bottom: 1px solid #c1c1c1;
}
.payroll-table__th-botton-b-right-actual-payment {
  text-align: center;
  height: 60px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #f47573;
  border-top: 1px solid #c1c1c1;
  border-right: 1px solid #d9d9d9;
  border-bottom: 1px solid #c1c1c1;
}
.payroll-table__bold-text {
  text-align: center;
  border: 1px solid #d9d9d9;
  height: 60px;
  padding: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
  background: #f9fafb;
}
.payroll-table__bold-text-right {
  border: 1px solid #d9d9d9;
  height: 60px;
  padding-right: 25px;
  text-align: right;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: #505054;
}
.payroll-table__name {
  display: flex;
}
.payroll-table__name__number {
  margin-left: 15px;
  margin-right: 15px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  display: flex;
  align-items: center;
  color: #999999;
}
.payroll-table__name__icon {
  background: #c1c1c1;
  height: 24px;
  width: 24px;
  border-radius: 50%;
}
.payroll-table__name__icon-default {
  background: #c1c1c1;
  height: 24px;
  width: 24px;
  border-radius: 50%;
  padding-left: 5px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 8px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: #ffffff;
}
.payroll-table__name__name {
  margin-left: 20px;
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #505054;
}
.payroll-table__td {
  text-align: center;
  border: 1px solid #d9d9d9;
  height: 60px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  color: #566370;
}
.payroll-table__td-actual-payment {
  text-align: center;
  border: 1px solid #d9d9d9;
  height: 60px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  color: #f47573;
}
.payroll-table__td-in {
  text-align: center;
  border-top: 1px solid #d9d9d9;
  height: 60px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  color: #566370;
}
.payroll-table__td-in-b-right {
  text-align: center;
  border-top: 1px solid #d9d9d9;
  height: 60px;
  font-family: "Noto Sans KR";
  font-style: normal;
  font-weight: 500;
  color: #566370;
  border-right: 1px solid #d9d9d9;
}
.payroll-table__td-icon {
  display: flex;
  padding-left: 30px;
}
.payroll-table__td-icon__icon {
  padding-left: 5px;
  cursor: pointer;
}

.note {
  margin-top: 30px;
}
.note__head {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 18px;
  color: #505054;
}
.note__text {
  font-family: "Spoqa Han Sans Neo";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}`, "",{"version":3,"sources":["webpack://./src/screens/payroll-register/payroll-register.scss"],"names":[],"mappings":"AAAA;EACI,SAAA;EACA,aAAA;EACA,WAAA;EACA,sBAAA;AACJ;AACI;EACI,eAAA;AACR;AAEI;EACI,aAAA;EACA,gBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AAAR;AAEQ;EACI,aAAA;AAAZ;AAGQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AADZ;AAIQ;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAFZ;;AAOA;EACI,aAAA;EACA,gBAAA;AAJJ;AAMI;EACI,kBAAA;AAJR;AAOI;EACI,YAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,8BAAA;AALR;;AASA;EACI,gBAAA;EACA,aAAA;AANJ;AAQI;EACI,YAAA;EACA,iBAAA;AANR;AASI;EACI,YAAA;EACA,yBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;AARR;;AAYA;EACI,SAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;AATJ;AAWI;EACI,yBAAA;EACA,mBAAA;EACA,oBAAA;EACA,8BAAA;EACA,+CAAA;AATR;AAYI;EACI,cAAA;AAVR;AAaI;EACI,cAAA;EACA,gBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,8BAAA;AAZR;AAeI;EACI,kBAAA;EACA,yBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;EACA,6BAAA;AAbR;AAgBI;EACI,aAAA;EACA,gCAAA;EACA,6BAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAdR;AAiBI;EACI,kBAAA;EACA,gCAAA;EACA,6BAAA;EACA,YAAA;EACA,aAAA;EAEA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AAhBR;AAmBI;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,8BAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;AAlBR;AAqBI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,mBAAA;AApBR;AAuBI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,+BAAA;AAtBR;AAyBI;EACI,kBAAA;EACA,YAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,gCAAA;AAxBR;AA2BI;EACI,kBAAA;EACA,YAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;AA1BR;AA6BI;EACI,kBAAA;EACA,YAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;AA5BR;AA+BI;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,mBAAA;AA9BR;AAiCI;EACI,yBAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAhCR;AAmCI;EACI,aAAA;AAjCR;AAmCQ;EACI,iBAAA;EACA,kBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAlCZ;AAqCQ;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;AAnCZ;AAsCQ;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AArCZ;AAwCQ;EACI,iBAAA;EAEA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,cAAA;AAvCZ;AA2CI;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EAEA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA1CR;AA6CI;EACI,kBAAA;EACA,yBAAA;EACA,YAAA;EAEA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA5CR;AA+CI;EACI,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;AA7CR;AAgDI;EACI,kBAAA;EACA,6BAAA;EACA,YAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,+BAAA;AA9CR;AAiDI;EACI,aAAA;EACA,kBAAA;AA/CR;AAiDQ;EACI,iBAAA;EACA,eAAA;AA/CZ;;AAoDA;EACI,gBAAA;AAjDJ;AAmDI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAjDR;AAoDI;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAlDR","sourcesContent":[".payroll-register {\n    flex: 1;\n    display: flex;\n    width: 100%;\n    flex-direction: column;\n\n    &__head {\n        font-size: 28px;\n    }\n\n    &__body {\n        display: flex;\n        margin-top: 20px;\n        padding: 2%;\n        flex-direction: column;\n        border-radius: 16px;\n        background: #ffffff;\n        gap: 10px;\n\n        &__head {\n            display: flex;\n        }\n\n        &__settlement-date {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #999999;\n        }\n\n        &__settlement-date-data {\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            color: #075453;\n        }\n    }\n}\n\n.payroll-select {\n    display: flex;\n    margin-top: 30px;\n\n    &__salary {\n        margin-right: 10px;\n    }\n\n    &__dropdown {\n        width: 170px;\n        height: 40px;\n        background: #ffffff;\n        border: 1px solid #e9e9e9;\n        border-radius: 8px 8px 8px 8px;\n    }\n}\n\n.selected-details {\n    margin-top: 50px;\n    display: flex;\n\n    &__excel {\n        float: right;\n        margin-left: auto;\n    }\n\n    &__excel-button {\n        height: 38px;\n        border: 1px solid #e1e1e1;\n        padding: 7px;\n        padding-left: 20px;\n        padding-right: 20px;\n        border-radius: 10px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 16px;\n        line-height: 22px;\n        text-align: center;\n        color: #505054;\n        cursor: pointer;\n    }\n}\n\n.payroll-table {\n    flex: 1;\n    display: flex;\n    margin-top: 30px;\n    width: 100%;\n    overflow-x: auto;\n\n    &__table-sticky {\n        border-collapse: collapse;\n        white-space: nowrap;\n        border-style: hidden;\n        border-radius: 6px 0px 0px 6px;\n        box-shadow: 10px 0 12px -2px rgba(0, 0, 0, 0.1);\n    }\n\n    &__table-scrollable::-webkit-scrollbar {\n        display: block;\n    }\n\n    &__table-scrollable {\n        display: block;\n        overflow-x: auto;\n        // scrollbar-width: none;\n        white-space: nowrap;\n        border-collapse: collapse;\n        border-radius: 0px 6px 6px 0px;\n    }\n\n    &__table {\n        text-align: center;\n        border-collapse: collapse;\n        width: 100%;\n        border-radius: 6px;\n        border-style: hidden;\n        box-shadow: 0 0 0 1px #e9e9e9;\n    }\n    \n    &__th-head {\n        padding: 20px;\n        border-bottom: 1px solid #e9e9e9;\n        border-top: 1px solid #868686;\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        align-items: center;\n        text-align: center;\n        color: #505054;\n        background: #f9fafb;\n    }\n\n    &__td {\n        text-align: center;\n        border-bottom: 1px solid #e9e9e9;\n        border-top: 1px solid #868686;\n        height: 60px;\n        padding: 15px;\n\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 500;\n        color: #566370;\n    }\n\n    &__th {\n        text-align: center;\n        border: 1px solid #d9d9d9;\n        height: 71px;\n        border-radius: 6px 0px 0px 6px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        align-items: center;\n        color: #868686;\n    }\n\n    &__th-in {\n        text-align: center;\n        height: 60px;\n        padding: 15px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        align-items: center;\n        color: #868686;\n        background: #f9fafb;\n    }\n\n    &__th-in-b-right {\n        text-align: center;\n        height: 60px;\n        padding: 15px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        line-height: 20px;\n        align-items: center;\n        color: #868686;\n        border-right: 1px solid #d9d9d9;\n    }\n\n    &__th-botton {\n        text-align: center;\n        height: 60px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n        border-top: 1px solid #c1c1c1;\n        border-bottom: 1px solid #c1c1c1;\n    }\n\n    &__th-botton-b-right {\n        text-align: center;\n        height: 60px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n        border-top: 1px solid #c1c1c1;\n        border-right: 1px solid #d9d9d9;\n        border-bottom: 1px solid #c1c1c1;\n    }\n\n    &__th-botton-b-right-actual-payment {\n        text-align: center;\n        height: 60px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #f47573;\n        border-top: 1px solid #c1c1c1;\n        border-right: 1px solid #d9d9d9;\n        border-bottom: 1px solid #c1c1c1;\n    }\n\n    &__bold-text {\n        text-align: center;\n        border: 1px solid #d9d9d9;\n        height: 60px;\n        padding: 15px;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n        background: #f9fafb;\n    }\n\n    &__bold-text-right {\n        border: 1px solid #d9d9d9;\n        height: 60px;\n        padding-right: 25px;\n        text-align: right;\n\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 14px;\n        line-height: 20px;\n        color: #505054;\n    }\n\n    &__name {\n        display: flex;\n\n        &__number {\n            margin-left: 15px;\n            margin-right: 15px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 400;\n            font-size: 12px;\n            line-height: 18px;\n            display: flex;\n            align-items: center;\n            color: #999999;\n        }\n\n        &__icon {\n            background: #c1c1c1;\n            height: 24px;\n            width: 24px;\n            border-radius: 50%;\n        }\n\n        &__icon-default {\n            background: #c1c1c1;\n            height: 24px;\n            width: 24px;\n            border-radius: 50%;\n            padding-left: 5px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 8px;\n            line-height: 16px;\n            display: flex;\n            align-items: center;\n            color: #ffffff;\n        }\n\n        &__name {\n            margin-left: 20px;\n\n            font-family: 'Spoqa Han Sans Neo';\n            font-style: normal;\n            font-weight: 700;\n            font-size: 14px;\n            line-height: 20px;\n            display: flex;\n            align-items: center;\n            color: #505054;\n        }\n    }\n\n    &__td {\n        text-align: center;\n        border: 1px solid #d9d9d9;\n        height: 60px;\n\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 500;\n        color: #566370;\n    }\n\n    &__td-actual-payment {\n        text-align: center;\n        border: 1px solid #d9d9d9;\n        height: 60px;\n\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 500;\n        color: #f47573;\n    }\n\n    &__td-in {\n        text-align: center;\n        border-top: 1px solid #d9d9d9;\n        height: 60px;\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 500;\n        color: #566370;\n    }\n\n    &__td-in-b-right {\n        text-align: center;\n        border-top: 1px solid #d9d9d9;\n        height: 60px;\n        font-family: 'Noto Sans KR';\n        font-style: normal;\n        font-weight: 500;\n        color: #566370;\n        border-right: 1px solid #d9d9d9;\n    }\n\n    &__td-icon {\n        display: flex;\n        padding-left: 30px;\n\n        &__icon {\n            padding-left: 5px;\n            cursor: pointer;\n        }\n    }\n}\n\n.note {\n    margin-top: 30px;\n\n    &__head {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 18px;\n        color: #505054;\n    }\n\n    &__text {\n        font-family: 'Spoqa Han Sans Neo';\n        font-style: normal;\n        font-weight: 400;\n        font-size: 12px;\n        line-height: 18px;\n        color: #999999;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
